import { incYenOf, incOf } from '../lib/pricing';
export const corporateHero = {
  title: '法人研修',
  titleEn: 'CORPORATE TRAINING',
  lead: '法人研修は、プロの執事が培った接遇の型をビジネスマナーとして指導する、出張型・来校型の研修プログラムです（執事資格を付与するものではありません）。ご希望に応じて受講証（参加証明）を発行します。',
};

export const trustBadges = [
  {
    icon: 'ri-user-star-line',
    text: '実技中心（演習8割）',
  },
  {
    icon: 'ri-building-line',
    text: '出張・来校どちらも対応',
  },
  {
    icon: 'ri-team-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const painPoints = [
  {
    icon: 'ri-vip-diamond-line',
    text: 'VIP・富裕層対応の品質を底上げしたい',
  },
  {
    icon: 'ri-store-2-line',
    text: '開業・リニューアルに向けて接遇の型を短期間で整えたい',
  },
  {
    icon: 'ri-emotion-unhappy-line',
    text: '座学中心のマナー研修では現場が変わらなかった',
  },
  {
    icon: 'ri-group-line',
    text: '管理職に「チームで品質を保つ仕組み」を持たせたい',
  },
];

export const industries = [
  {
    id: 'hotel',
    name: 'ホテル・旅館',
    description: '開業前研修からバトラーサービスの型まで',
    href: '/corporate/hotel',
    imageSeq: 'corporate-hotel',
  },
  {
    id: 'residence',
    name: '高級レジデンス',
    description: 'コンシェルジュ・フロントの接遇品質を統一',
    href: '/corporate/residence',
    imageSeq: 'corporate-residence',
  },
  {
    id: 'finance',
    name: '金融・プライベートバンク',
    description: '富裕層対応の信頼を所作から築く',
    href: '/corporate/finance',
    imageSeq: 'corporate-finance',
  },
  {
    id: 'retail',
    name: '百貨店外商・高級小売',
    description: 'お得意様対応と訪問の作法',
    href: '/corporate/retail',
    imageSeq: 'corporate-retail',
  },
  {
    id: 'luxury-sales',
    name: 'ラグジュアリー営業',
    description: '高級車・宝飾・不動産の商談体験を設計',
    href: '/corporate/luxury-sales',
    imageSeq: 'corporate-luxury-sales',
  },
  {
    id: 'clinic',
    name: '医療・美容クリニック',
    description: '自由診療の接遇を院内に定着',
    href: '/corporate/clinic',
    imageSeq: 'corporate-clinic',
  },
  {
    id: 'automotive',
    name: '自動車・モビリティ',
    description: 'ブランド体験・イベントのおもてなしを高める',
    href: '/corporate/automotive',
    imageSeq: 'corporate-automotive',
  },
  {
    id: 'chauffeur',
    name: 'ハイヤー・送迎',
    description: '乗降の所作と車内の気配りを磨く',
    href: '/corporate/chauffeur',
    imageSeq: 'corporate-chauffeur',
  },
];

export const trainingModules = [
  {
    id: 'M1',
    title: '執事流の立ち居振る舞いと身だしなみ',
    description:
      '第一印象を決める立ち姿・歩き方・所作を、執事の基準で一つひとつ点検し矯正します。写真撮影によるビフォーアフター比較で、受講生ご自身が変化を実感できる構成です。',
    imageSeq: 'corporate-module-1',
  },
  {
    id: 'M2',
    title: 'VIP・富裕層対応の原則',
    description:
      '呼称・敬語・距離感・守秘義務など、信頼を損なわないための原則を実例をもとに学びます。富裕層ゲストが無意識に感じ取る「違和感」を排除し、安心感を与える接し方を身につけます。',
    imageSeq: 'corporate-module-2',
  },
  {
    id: 'M3',
    title: 'ティー＆テーブルサービス実技',
    description:
      'お茶出しと卓上の整えを実技で行い、所作の精度を体に入れます。茶器の扱い、温度管理、美しい注ぎ方から下膳のタイミングまで、一連の流れを反復練習します。',
    imageSeq: 'corporate-module-3',
  },
  {
    id: 'M4',
    title: 'クレーム・想定外対応',
    description:
      '初動の重要性と代替案の組み立て方を、貴社の実際の事例を題材にロールプレイングします。感情的にならず、ゲストの真の要望を見抜いて最短で解決へ導く思考法を訓練します。',
    imageSeq: 'corporate-module-4',
  },
  {
    id: 'M5',
    title: '電話・メール・チャットの品格',
    description:
      '言葉選びと型を整え、文章にも品格を持たせます。声のトーン・間の取り方・文面の構成まで、非対面コミュニケーションだからこそ差がつく要素を体系的に指導します。',
    imageSeq: 'corporate-module-5',
  },
  {
    id: 'M6',
    title: 'チームで提供するおもてなし',
    description:
      '管理職向けに、基準づくり・観察・フィードバックのサイクルでサービス品質を保つ仕組みを扱います。属人化を防ぎ、チーム全体で一定水準を維持するマネジメント手法を学びます。',
    imageSeq: 'corporate-module-6',
  },
];

export const pricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '2日間パッケージ',
    duration: '12時間（2日間）',
    price: incYenOf('ct-single-2day'),
    note: '全6モジュール受講可',
  },
  {
    name: '開業前集中',
    duration: '18時間（3日間）',
    price: incYenOf('ct-single-intensive3'),
    note: '開業準備に特化した集中設計',
  },
  {
    name: '継続プログラム',
    duration: '月1回半日×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    note: '定着と改善を繰り返す長期設計',
  },
];

export const pricingOptions = [
  {
    name: '覆面サービス診断',
    price: `${incYenOf('ct-opt-mystery')}〜`,
    note: '現場診断＋報告書',
  },
  {
    name: '教材カスタム開発',
    price: `${incYenOf('ct-opt-material')}〜`,
    note: '貴社専用のテキスト・マニュアル制作',
  },
];

export const pricingConditions = {
  dispatch: '出張（全国対応・交通費宿泊費は実費別途）',
  capacity: '推奨人数12名まで（超過は2班制等をご提案）',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
};

export const flowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description: '対象人数・課題・希望時期などをオンラインまたはお電話で伺います。',
  },
  {
    step: '03',
    title: 'プログラム提案・お見積り',
    description: 'ヒアリング内容をもとに、最適な研修プログラムとお見積りをご提案します。',
  },
  {
    step: '04',
    title: '実施',
    description: '出張または来校にて研修を実施します。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const industryOptions = [
  { value: '', label: '選択してください' },
  { value: 'hotel', label: 'ホテル・旅館' },
  { value: 'residence', label: '高級レジデンス' },
  { value: 'finance', label: '金融' },
  { value: 'retail', label: '百貨店・小売' },
  { value: 'luxury-sales', label: 'ラグジュアリー営業' },
  { value: 'clinic', label: '医療・クリニック' },
  { value: 'automotive', label: '自動車・モビリティ' },
  { value: 'chauffeur', label: 'ハイヤー・送迎' },
  { value: 'other', label: 'その他' },
];

export const formatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const corporateFaqs = [
  {
    question: '1回の研修で何名まで受講できますか？',
    answer:
      '実技の品質を保つため12名までを推奨しています。それ以上の場合は2班制や複数回開催などの形式をご提案しますのでご相談ください。',
  },
  {
    question: '地方への出張は可能ですか？',
    answer:
      'はい、全国へ出張いたします。講師の交通費・宿泊費は実費を別途申し受けます。',
  },
  {
    question: '研修内容のカスタマイズはできますか？',
    answer:
      'はい。事前ヒアリングのうえ、6つのモジュールの組合せや貴社事例の組み込みなど、課題に合わせて設計いたします。',
  },
  {
    question: '支払い方法を教えてください。',
    answer:
      '請求書払い（銀行振込）にて承ります。分割払い・クレジットカードはご利用いただけません。',
  },
];

export const relatedPages = [
  {
    title: 'アカデミーについて',
    description: '日本執事アカデミーの理念と概要',
    href: '/about',
  },
  {
    title: 'カリキュラム',
    description: '執事養成課程の全体像',
    href: '/curriculum',
  },
  {
    title: '講師紹介',
    description: '順次公開予定',
    href: '#',
    comingSoon: true,
  },
  {
    title: 'アクセス',
    description: '東京・お台場の校舎へのご案内',
    href: '/access',
  },
];